/* ===================================================================
   useSession() -- read the current Supabase Auth session.

   Kept in its own module (separate from SessionProvider.tsx) so the
   provider file only exports components -- this keeps react-refresh
   happy and lets non-component code import the hook cleanly.
   =================================================================== */

import { useContext } from 'react';
import { SessionContext } from './context';
import type { SessionContextValue } from './context';

export function useSession(): SessionContextValue {
  const ctx = useContext(SessionContext);
  if (ctx === undefined) {
    throw new Error('useSession() must be used within a <SessionProvider>.');
  }
  return ctx;
}
